import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadLandingPageDomain } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type GetLandingPageDomainParams = {
  organizationId: string;
};

export const getLandingPageDomain = async (
  params: GetLandingPageDomainParams,
): Promise<ReadLandingPageDomain> => {
  return await tinctApi.landingPageDomain.getLandingPageDomain(
    params.organizationId,
  );
};

export const useGetLandingPageDomain = (
  params: GetLandingPageDomainParams,
  options?: Omit<UseQueryOptions<ReadLandingPageDomain, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['landing-page-domain', params.organizationId],
    queryFn: () => getLandingPageDomain(params),
    ...options,
  });
